jQuery(function($) {
    $("body:not(.template-index)").on("click", '.menu-open', function() {
        $('.transparence').fadeToggle();
        $(this).addClass('close-show-button');
        $('.hidden-menu').slideDown();   
    });
    $("body:not(.template-index)").on("click", '.close-show-button', function() {
        $('.transparence').fadeOut();
        $('.menu-open.close-show-button').removeClass('close-show-button');
        $('.hidden-menu').slideUp();   
    });
    $('body:not(.template-index)').on('click', '.transparence', function() {
        $('.hidden-menu').hide();
        $('.menu-open').toggleClass("close-show-button");
        $('.menu-open').show();
        $(this).fadeOut();
    });  
    //$(".search-top").hide();
    $('.search-closed-black').on("click", function() {
        $("form.search").fadeToggle();
        $(this).toggleClass("search-open-header-black");
    });

    $('.mobile-filter').on('click', function() {
      console.log("this clicked.");
      $('.left-products-listing').slideToggle();
    });

//HOVER EFFECT TRANSITION
    $('.image-product-listing').hover(function() {
        var imgCount = $(this).find('img').length;
        if(imgCount > 1) {
            var prdID = $(this).attr('prd-id');
            $(this).find('img:first').fadeTo(0, 0);
            $(this).find('img:last').fadeTo(0, 1);
        }
    }, function() {
        var imgCount = $(this).find('img').length;
        if(imgCount > 1) {
            var prdID = $(this).attr('prd-id');
            $(this).find('img:first').fadeTo(0, 1);
            $(this).find('img:last').fadeTo(0, 0);
        }
    });

    $('body').on('click', 'a.add-to-cart-listing:not(.sold-out)', function(e) {
        e.preventDefault();
        var productID = $(this).attr('product-id');
        $('form#form-to-atc input#myproductID').val(productID).attr('value', productID);
        $('form#form-to-atc button[type="submit"]').trigger('click');
    });
    $('body').on('submit', 'form#form-to-atc', function(e) {
        e.preventDefault();
        var productID = $('form#form-to-atc input#myproductID').val();
        var cartCount = $('span[cart-item]').attr('cart-item');
        jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                quantity: 1,
                id: productID
            },
            beforeSend: function() {
                $('a.add-to-cart-listing[product-id="'+productID+'"]').addClass('disabled').html('<i class="fas fa-spinner fa-pulse"></i> Processing..');
            },
            success: function(data) {
                $('.added-to-cart-top').fadeIn();
                var cartCount = $('span[cart-item]').attr('cart-item');
                var sum = Number(cartCount) + 1;
                $('span[cart-item]').attr('cart-item', sum).html(sum);
                setTimeout(function() {
                    $('.added-to-cart-top').fadeOut();
                    $('.add-to-cart-listing').removeClass('disabled').html('Add To Cart');
                }, 1000);
            }
        });
    });    


//shopping cart
if($('body').hasClass('template-cart')) {
    $('body').on('click', 'a.add-to-cart-listing.btn-width-full', function(e) {
        e.preventDefault();
        $('input[type="submit"][name="checkout"]').trigger('click');
    });
    //var itemCount = $('tr[item-id]');
    $('.loader-first-table').on('click', 'button.remove-from-cart', function(e) {
        e.preventDefault();
        var itemID = $(this).attr('item-id');
        var removeURL = $(this).attr('item-url');
        setTimeout(function() {
            if($('tr[item-id]').length == '0') {
                $.get(location.href).then(function(page) {
                    $(".cart-section-table").html(
                        $(page).find(".cart-section-table").html()
                    );
                });
            }
            //$('.cart-top-header span[cart-item]').html($('tr[item-id]').length).attr('cart-item', $('tr[item-id]').length);
        }, 2000);
        jQuery.ajax({
            type: 'POST',
            url: removeURL,
            dataType: 'json',
            beforeSend: function() {
                $('.overlayload').fadeIn();
            },
            success: function() {
                $('tr[item-id="'+itemID+'"]').remove();
                $.get(location.href).then(function(page) {
                    $(".loader-first-table").html(
                        $(page).find(".loader-first-table").html()
                    );
                });
                $.get(location.href).then(function(page) {
                    $(".table-shopping-cart.reload").html(
                        $(page).find(".table-shopping-cart.reload").html()
                    );
                });
                $.get(location.href).then(function(page) {
                    $('.item-cart-counter').html(
                        $(page).find('.item-cart-counter').html()
                    );
                }); 
                setTimeout(function() {
                    $('.overlayload').fadeOut();
                }, 2000);
            },
            error: function() {
                alert('ERROR');
            }
        });
    });
    $('.loader-first-table').on('keyup keydown', 'input.form-control.input-number', function(e) {
        e.preventDefault();
    });
    $('.loader-first-table').on('click', 'button[data-type="plus"]', function() {
        var attrID = $(this).attr('prdID');
        var value = $('input.form-control.input-number[prdID="'+attrID+'"]');
        var value_q = $('.cartinputQTY[itempID="'+attrID+'"]');
        value.val(+value.val() + 1);
        value_q.val(+value_q.val() + 1);

    });
    $('.loader-first-table').on('click', 'button[data-type="minus"]', function() {
        var attrID = $(this).attr('prdID');
        var value = $('input.form-control.input-number[prdID="'+attrID+'"]');
        var value_q = $('.cartinputQTY[itempID="'+attrID+'"]');
        if(value.val() != 1) {
          value.val(parseFloat(value.val()) - Number(1));
          value_q.val(parseFloat(value_q.val()) - Number(1));
        }
    });
    $('body').on('click', 'button.btn-width-full.cart-btn-shopping-black[name="update"]', function(e) {
        e.preventDefault();
        $.ajax({
            type:'POST',
            url: '/cart/update.js',
            data: $('form.to-cart').serialize(),
            dataType: 'json',
            beforeSend: function() {
                $('.overlayload').fadeIn();
            },
            success: function(data) {

                $.get(location.href).then(function(page) {
                    $(".loader-first-table").html(
                        $(page).find(".loader-first-table").html()
                    );
                });
                $.get(location.href).then(function(page) {
                    $(".table-shopping-cart.reload").html(
                        $(page).find(".table-shopping-cart.reload").html()
                    );
                });
                $.get(location.href).then(function(page) {
                    $('.item-cart-counter').html(
                        $(page).find('.item-cart-counter').html()
                    );
                }); 
                setTimeout(function() {
                    $('.overlayload').fadeOut();
                }, 2000);
            },
            error: function() {
                alert('ERROR');
            }
        });
    });
}

//ajax FrontPage
if($('body').hasClass('template-index')) {
    $("body").on("click", '.menu-open-home', function() {

        $('.transparence').fadeToggle();
        $(this).addClass('close-show-button');
        $('.hidden-menu').slideDown();   
    });
    $("body").on("click", '.close-show-button', function() {
        $('.transparence').fadeOut();
        $('.menu-open-home.close-show-button').removeClass('close-show-button');
        $('.hidden-menu').slideUp();   
    });
    $('body').on('click', '.transparence', function() {
        $('.hidden-menu').hide();
        $('.menu-open-home').toggleClass("close-show-button");
        $('.menu-open-home').show();
        $(this).fadeOut();
    });       

    $('body').on('click', '.search-home-closed', function() {
        $("form.search").fadeToggle();
        $(this).toggleClass("search-open-header-black");
    });

    $('body').on('click', '.add-to-cart-listing:not(.sold-out)', function(e) {
        e.preventDefault();
        var productID = $(this).attr('product-id');
        $('form#addFP input[name="id"]').val(productID).attr('value', productID);
        setTimeout(function() {
            $('form#addFP input[type="submit"]').trigger('click');
        }, 500);
    });

    $('form#addFP').on('submit', function(e) {
        e.preventDefault();
        var productID = $('form#addFP input[name="id"]').val();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                quantity: 1,
                id: productID
            },
            beforeSend: function() {
                $('a.add-to-cart-listing[product-id="'+productID+'"]').addClass('disabled').html('<i class="fas fa-spinner fa-pulse"></i> Processing..');
            },
            success: function(data) {
                $('.added-to-cart-top').fadeIn();
                var cartCount = $('span[cart-item]').attr('cart-item');
                var sum = Number(cartCount) + Number(1);
                $('span[cart-item]').attr('cart-item', sum).html(sum);
                setTimeout(function() {
                    $('.added-to-cart-top').fadeOut();
                    $('.add-to-cart-listing').removeClass('disabled').html('Add To Cart');
                }, 1000);
            },
            error: function() {
                alert('ERROR');
            }
        });
    });
    var owl = $('.sliderHome');
    owl.owlCarousel({
        items: 4,
        autoplay: true,
        navigation : false,
        pagination : false
    });
    $(function() {
        var header = $('.home-header-transparece');
        // var menu = $('#menu');
        var hieghtThreshold = $(".white-section").offset().top;
        var hieghtThreshold_end  = $(".white-section").offset().top +$(".white-section").height() ;
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll >= hieghtThreshold) {
                header.css('background-color', '#145CE8');
                // menu.addClass('dark');
            } else {
                header.css('background-color', 'transparent');
                // menu.removeClass('dark');
            }
        });
    });
}


//AJAX TO SINGLE PRODUCT PAGE
if($('body').hasClass('template-product')) {
  $('input.form-control.input-number').on('keydown keyup', function(e) {
    e.preventDefault();
  });
  $('button[data-type="plus"]').on('click', function() {
    var value = $('input.form-control.input-number');
    var value_q = $('#Quantity');
    value.val(+value.val() + 1);
    value_q.val(+value_q.val() + 1);
  });
  $('button[data-type="minus"]').on('click', function() {
    var value = $('input.form-control.input-number');
    var value_q = $('#Quantity');
    if(value.val() != 1) {
      value.val(parseFloat(value.val()) - Number(1));
      value_q.val(parseFloat(value_q.val()) - Number(1));
    }
  });
  $('body').on('click', '.add-to-cart-listing:not(.relAdd)', function(e) {
    e.preventDefault();
    if($('input.form-control.input-number').val() != 0) {
        $('.addtocart_fn').trigger('click');
    }
  });
  $('.shopify-product-form').on('submit', function(e) {
    e.preventDefault();
    var curCount = $('input.form-control.input-number').val();
    $.ajax({
        type:'POST',
        url: $(this).attr('action'),
        data: $(this).serialize(),
        beforeSend: function() {
            $('.add-to-cart-listing').addClass('disabled').html('<i class="fas fa-spinner fa-pulse"></i> Add To Cart');
        },
        success: function(data) {
            $('.added-to-cart-top').fadeIn();
            var cartCount = $('span[cart-item]').attr('cart-item');
            var sum = Number(cartCount) + Number(curCount);
            $('span[cart-item]').attr('cart-item', sum).html(sum);
            setTimeout(function() {
                $('.added-to-cart-top').fadeOut();
                $('.add-to-cart-listing').removeClass('disabled').html('Add To Cart');
            }, 1000);
        },
        error: function() {
            alert('ERROR');
        }
    });
  });
  var sync1 = $("#sync1");
  var sync2 = $("#sync2");
 
  sync1.owlCarousel({
    items: 1,
    slideSpeed : 1000,
    navigation: false,
    pagination:false,
    afterAction : syncPosition,
    responsiveRefreshRate : 200,
    itemsDesktop      : [1199,1],
    itemsDesktopSmall     : [979,1],
    itemsTablet       : [768,1],
    itemsMobile       : [479,1]
  });
 
  sync2.owlCarousel({
    items : 3,
    itemsDesktop      : [1199,3],
    itemsDesktopSmall     : [979,3],
    itemsTablet       : [768,3],
    itemsMobile       : [479,3],
    pagination:false,
    responsiveRefreshRate : 100,
    afterInit : function(el){
      el.find(".owl-item").eq(0).addClass("synced");
    }
  });
 
  function syncPosition(el) {
    var current = this.currentItem;

this
   .$owlItems
   .removeClass('active')

   //add class active
   this
   .$owlItems //owl internal $ object containing items
   .eq(this.currentItem)
   .addClass('active') 

    $("#sync2")
      .find(".owl-item")
      .removeClass("synced")
      .eq(current)
      .addClass("synced")
    if($("#sync2").data("owlCarousel") !== undefined){
      center(current)
    }
  }
 
  $("#sync2").on("click", ".owl-item", function(e){
    e.preventDefault();
    var number = $(this).data("owlItem");
    sync1.trigger("owl.goTo",number);
  });
 
  function center(number){
    var sync2visible = sync2.data("owlCarousel").owl.visibleItems;
    var num = number;
    var found = false;
    for(var i in sync2visible){
      if(num === sync2visible[i]){
        var found = true;
      }
    }
 
    if(found===false){
      if(num>sync2visible[sync2visible.length-1]){
        sync2.trigger("owl.goTo", num - sync2visible.length+2)
      }else{
        if(num - 1 === -1){
          num = 0;
        }
        sync2.trigger("owl.goTo", num);
      }
    } else if(num === sync2visible[sync2visible.length-1]){
      sync2.trigger("owl.goTo", sync2visible[1])
    } else if(num === sync2visible[0]){
      sync2.trigger("owl.goTo", num-1)
    }
    
  }
    $('.owl-recommended').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        items:3
    });

    $('.product-image-container .owl-item .item.custImg img').on('mouseenter', function(e) {
        $(this).ezPlus();
    });

    $('body').on('click', 'a.add-to-cart-listing:not(.full-width-cart-single)', function(e) {
        e.preventDefault();
        var productID = $(this).attr('product-id');
        $('form#form-to-atc input#myproductID').val(productID).attr('value', productID);
        $('form#form-to-atc button[type="submit"]').trigger('click');
    });
    $('body').on('submit', 'form#form-to-atc', function(e) {
        e.preventDefault();
        var productID = $('form#form-to-atc input#myproductID').val();
        var cartCount = $('span[cart-item]').attr('cart-item');
        jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                quantity: 1,
                id: productID
            },
            beforeSend: function() {
                $('a.add-to-cart-listing[product-id="'+productID+'"]').addClass('disabled').html('<i class="fas fa-spinner fa-pulse"></i> Processing..');
            },
            success: function(data) {
                $('.added-to-cart-top').fadeIn();
                var cartCount = $('span[cart-item]').attr('cart-item');
                var sum = Number(cartCount) + 1;
                $('span[cart-item]').attr('cart-item', sum).html(sum);
                setTimeout(function() {
                    $('.added-to-cart-top').fadeOut();
                    $('.add-to-cart-listing').removeClass('disabled').html('Add To Cart');
                }, 1000);
            }
        });
    });

      if(Cookies.getJSON('wishlist') == null) {
        var wishvalues = [];
      } else {
        var wishvalues = Cookies.getJSON('wishlist');
        var productID = $('.wishlist-actions').attr('wishid');
        jQuery.each(Cookies.getJSON('wishlist'), function(index, value) {
          if(value == productID) {
            $('#add-wishlist').remove();
            $('#add-wishlist').attr('href', '/pages/wishlist');
            $('.wishlist-actions i').css('color', 'red');
            $('.wishlist-actions').append('<a href="/account/" class="add-review-right-content no-margin-right"><span style="text-decoration:none;" class="add-review-right-content no-margin-right">Already added to wishlist</span></a>');
          }
        });
      }
      $('body').on('click', '#add-wishlist', function(e) {
        e.preventDefault();
        $(this).html('<i class="fas fa-spinner fa-pulse"></i> adding to list..').css('pointer-events', 'none');
        var currentID = $(this).attr('product_id');
        wishvalues.push(currentID);
        Cookies.set('wishlist', wishvalues);
        setTimeout(function() {
          $('#add-wishlist').attr('href', '/account/');
          $('.wishlist-actions i').css('color', 'red');
          $('#add-wishlist').html('<span style="text-decoration:none;" class="add-review-right-content no-margin-right">Already added to wishlist</span>');
        }, 600);
      });

      $('.remove-cookie').on('click', function() {
        Cookies.remove('wishlist');
      });

      $('#non-logged').on('click', function(e) {
        e.preventDefault();
        $('.wishlist-actions p.message').fadeIn();
      });
}

$('#tabs li a:not(:first)').addClass('inactive');
$('.tab-content').hide();
$('.tab-content:first').show();

$('#tabs li a').click(function() {
        var t = $(this).attr('id');
        if($(this).hasClass('inactive')){ //this is the start of our condition 
        $('#tabs li a').addClass('inactive');           
        $(this).removeClass('inactive');

        $('.tab-content').hide();
        $('#'+ t + 'C').fadeIn('slow');
    }    
});

if($('body').hasClass('template-login')) {
    $('body').on('click', 'a.sign-in-customer.login', function(e) {
        e.preventDefault();
        if($('form input#CustomerEmail').val() == '') {
            $('p.custom-errors').fadeIn(function() {
                $(this).html("Email field can't be empty");
            });
        } 
        else if($('form input#CustomerPassword').val() == '') {
            $('p.custom-errors').fadeIn(function() {
                $(this).html("Password field can't be empty");
            });            
        }
        else if ($('form input#CustomerEmail').val() == '' && $('form input#CustomerPassword').val() == '') {
            $('p.custom-errors').fadeIn(function() {
                $(this).html("Fields can't be empty");
            });       
        }
        else if ($('form input#CustomerEmail').val() != '' && $('form input#CustomerPassword').val() != '') {
            $('p.custom-errors').fadeOut();
            $('input[type="submit"]').trigger('click');
        }
    });
}

if($('body').hasClass('template-account')) {
      setTimeout(function() {
    $('.loading').fadeOut();
    $('.results').fadeIn();
  }, 1500);
if(Cookies.getJSON('wishlist') == null) {
  $('.results').append('<h1 style="width: 100%;text-align: center;padding: 4%;">Your wishlist is empty</h1>');
} else if(Cookies.getJSON('wishlist') == '') {
  $('.results').append('<h1 style="width: 100%;text-align: center;padding: 4%;">Your wishlist is empty</h1>');
}
$.each(Cookies.getJSON('wishlist'), function(index, value) {
$.getJSON('/products/'+value+'.json', function(product) {
  var featured_image;
  if(product.product.image != null) {
    featured_image = product.product.image.src;
  } else if(product.product.image == null) {
    featured_image = 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large.gif';
  }
  var product_title = product.product.title;
  var product_price = product.product.variants[0].price;
  var product_handle = '/products/'+product.product.handle;
  var product_category = product.product.product_type;
  var template = '<div handle="'+product.product.handle+'" class="col-lg-4 col-md-4 col-sm-12 col-xs-12 products-listing"><div class="image-product-listing" prd-id=""><a class="product-link" href="'+product_handle+'"><img class="thumb" src="'+featured_image+'" /></a></div><div class="row"><div class="col-6"><span class="category-product-listing">'+product_category+'</span></div><div class="col-6 rating-reviews"><span class="shopify-product-reviews-badge" data-id=""></span></div></div><h3 class="title-product-listing"><a href="'+product_handle+'">'+product_title+'</a></h3><span class="price-category-listing">'+product_price+'</span><a id="remove-item" product-id="'+product.product.handle+'" class="add-to-cart-listing add-to-cart-listing-home" href="#" data-toggle="tooltip" data-placement="top" title="Remove from my wishlist">Remove</a></div>';
  $('.results').append(template);
});
});
$('.results').on('click', '#remove-item', function(e) {
  if(Cookies.getJSON('wishlist') != null) {
    var curitem = $(this).attr('product-id');
    var wishvalues = Cookies.getJSON('wishlist');
    wishvalues.splice($.inArray(curitem, wishvalues), 1);
    Cookies.set('wishlist', wishvalues);
    $(this).html('<i class="fas fa-spinner fa-pulse"></i> Deleting..').css('pointer-events', 'none');
    setTimeout(function(){
      $('div[handle="'+curitem+'"]').fadeOut();
    }, 600);
  }
});
}

if($('body').hasClass('template-register')) {
    $('body').on('click', 'a.sign-in-customer.register', function(e) {
        e.preventDefault();

        if($('input#FirstName').val() == '') {
            $('.custom-errors').html("<p>First Name field can't be empty<p>");
        } else if($('input#LastName').val() == '') {
            $('.custom-errors').html("<p>Last Name field can't be empty<p>");
        } else if($('input#Email').val() == '') {
            $('.custom-errors').html("<p>Email field can't be empty<p>");
        } else if($('input#CreatePassword').val() == '') {
            $('.custom-errors').html("<p>Password field can't be empty<p>");
        } 
        if($('input#FirstName').val() != '' && 
            $('input#LastName').val() != '' && 
            $('input#Email').val() != '' &&
            $('input#CreatePassword').val() != '') {
                $('input[type="submit"]').trigger('click');
        }

    });

}

if($('body').attr('id') == 'contact-us') {
    $('body').on('click', 'a.sign-in-customer.contactsubmit', function(e) {
        e.preventDefault();
        $('form#contact_form input[type="submit"]').trigger('click');
    });
}



if($('body').hasClass('template-collection')) {
    $('.product-list-column').ready(function() {
        var countItem = $('.products-listing.product-item');
        if(countItem.length > 12) {
            $('.product-list-column').infiniteScroll({
              path: '.pagination__next',
              append: '.product-item',
              status: '.scroller-status',
              hideNav: '.pagination',
            });

        } else if(countItem.length < 12) {
            $('.scroller-status').remove();
        }
    });
}

});

//review JS
var tmrReady = setInterval(isPageFullyLoaded, 100);
function isPageFullyLoaded() {
    if (document.readyState == "complete") {
        setTimeout(function(){
            $(window).ready(function () {
                var text = new Array();
                var numReviews = $('.spr-summary-actions-togglereviews').text();
                if(numReviews > 0){
                    $('.spr-header-title').append(' ('+numReviews+')');
                }
                $('.spr-review-header-title').each(function(){
                    text.push($(this).text());
                });
                $('.spr-review-content-body').each(function(i = 0){
                    $(this).before('<h3 class="spr-review-header-title-right">'+text[i]+'</h3>');
                    i++;
                });
            });
        },2000);
        clearInterval(tmrReady);
    }
}


$(document).click(function(){
    setTimeout(function(){
                $('.spr-review-header-title-right').remove();
                var text = new Array();
                $('.spr-review-header-title').each(function(){
                    text.push($(this).text());
                });
                $('.spr-review-content-body').each(function(i = 0){
                    $(this).before('<h3 class="spr-review-header-title-right">'+text[i]+'</h3>');
                    i++;
                })
        },1000)
});

    function getParameterByName (name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    function getTags (input) {
        var inputTags = [];
                var cont = 0;
                $('.price input[type="checkbox"]').each(function(){
                    if($(this).prop("checked") == true){
                        cont++;
                    }
                });
                var thisImput = input;
                if(cont > 1){
                    $('.price input[type="checkbox"]').each(function(){
                        if(thisImput.className != this.className){
                            $(this).prop( "checked", false );
                        }
                    });
                }
                $('input[type="checkbox"]').each(function(){
                    if($(this).prop("checked") == true){
                        inputTags.push($(this).val());
                    }
                });
        return inputTags;
    }

    function ajaxGet (url) {
        $.get(url).then(function(page){
            $(".product-list-column").html(
                $(page).find(".product-list-column").html()
            );
            history.pushState({ page: url }, url, url);
        });
    }

    $(document).ready(function(){
        var sort_by = getParameterByName('sort_by');
        if(sort_by){
            $('#dropdownMenuButton span').text(sort_by.replace('-',' ')+' ');
        }
    });

var tmr = setInterval(isPageLoaded, 100);
function isPageLoaded() {
    if (document.readyState == "complete") {
        setTimeout(function(){
            $(window).ready(function () {
                $('.spr-badge-caption').each(function(){
                    if($(this).text() == 'No reviews'){
                        $(this).show();
                    }
                });
            });
        },3000);
        clearInterval(tmr);
    }
}

$("ul.menu-footer li.parentMenu").click(function(){
    $(this).find("ul").toggle();
}); 

//ANIMATIONS
$(document).ready(function() {
    if(!$('body').hasClass('template-account')) {
        ScrollReveal().reveal('.headline', {delay: 500, easing: 'easing-in-out', origin: 'top', distance: '50px'});
        ScrollReveal().reveal('.linereveal', {delay: 500, easing: 'cubic-bezier(0.5, 0, 0, 1)', origin: 'bottom', distance: '100px'});
        ScrollReveal().reveal('.heroreveal', {delay: 500, easing: 'ease-in', origin: 'bottom', distance: '100px'});
        ScrollReveal().reveal('.linereveal-l', {delay: 500, easing: 'ease', origin: 'left', distance: '200px'});
        ScrollReveal().reveal('.linereveal-r', {delay: 500, easing: 'ease', origin: 'right', distance: '200px'});
    }
});